import { MapSubtitles } from '../../services/recomendacao-semeadura-mapa';

const DEFAULT_STYLES = {
  width: '25px',
  height: '25px',
  borderRadius: '5px',
  marginRight: '10px',
};

const Subtitle = ({ legendas }: PropTypes) => (
  <div className="legenda">
    {legendas.map((legenda) => {
      const style = {
        ...DEFAULT_STYLES,
        backgroundColor: legenda.cor,
      };

      return (
        <div
          key={legenda.descricao}
          className="flex flex-row align-items-center"
        >
          <div style={style} />
          <p className="label">{legenda.descricao}</p>
        </div>
      );
    })}
  </div>
);

type PropTypes = {
  legendas: MapSubtitles[];
};

export default Subtitle;
